import { connect } from 'react-redux';
import { login } from '../../redux/actions/session_actions';
import LogInPage from './LogInPage';

const mapStateToProps = (state) => {
    return {
        errors: state.errors.session
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        login: user => dispatch(login(user)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogInPage);